export default "__VITE_ASSET__eac760a5__"